import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { ColumnComponent } from '../column.component';

@Component({
  selector: 'app-column-quantity',
  templateUrl: './column-quantity.component.html',
  styleUrls: ['./column-quantity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ColumnQuantityComponent extends ColumnComponent {
  @Input() useNgContent: boolean;
}
